var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LabeledInput',{model:{value:(_vm.value.foo),callback:function ($$v) {_vm.$set(_vm.value, "foo", $$v)},expression:"value.foo"}})
}
var staticRenderFns = []

export { render, staticRenderFns }